import { Grid as BaseGrid, styled } from '@mui/material'

export const Row = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`
